import React from 'react';
import {
  Text,
  Wrapper,
  ResponseImg,
  ResponseModal,
} from './styles';

interface ErrorModalProps {
  title: any,
  errorMessage: any,
  icon: any,
  showCloseButton: boolean,
  onCloseModal: () => any,
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  title,
  errorMessage,
  icon,
  showCloseButton,
  onCloseModal,
}) => (
  <ResponseModal
    showCloseButton={showCloseButton}
    openModal
    title={title}
    onClosedModal={onCloseModal}
    headerColor="red"
  >
    {() => (
      <Wrapper>
        <ResponseImg src={icon} alt="error" />
        <Text>{errorMessage}</Text>
      </Wrapper>
    )}
  </ResponseModal>
);

export default ErrorModal;
